import { gql } from '@apollo/client';
export const CUSTOMER_QUERIES = {
GET_ALL_CUSTOMERS: gql`
query GetAllCustomers(
  $search: String
  $sortBy: String
  $sortOrder: String
) {
  getAllCustomers(
    search: $search
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    customers {
      id
      name
      phone
      email
      gender
      image
      created_at
      updated_at
      address_type {
        id
        label
        latitude
        longitude
        address
        pincode
      }
    }
  }
}
`,
ADD_CUSTOMER: gql`
    mutation AddCustomer($input: AddCustomerInput!) {
      addCustomer(input: $input) {
        customer {
        id
        name
        phone
        email
        gender
        image
        created_at
        updated_at
        }
        success
        message
      }
    }
  `,
}
